import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import SmartBanner from 'react-smartbanner'
import 'react-smartbanner/dist/main.css'

import history from '../history'
import Navbar from '../containers/Navbar'
import Notifications from '../containers/Notifications'

import Main from './Main'
import Dashboard from './Dashboard'
import Email from './Email'

// import { AuthPage } from '../containers/Pages/Main'

const Routes = () => {
  return (
    <React.Fragment>
      <ConnectedRouter history={history}>
        <React.Fragment>
          <Navbar />
          <SmartBanner title={'HRS Service Desk'} />

          {/* <Container> */}
          <Switch>
            <Route path="/email" component={Email} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/" component={Main} />
            {/* <Route component={withAuth(AuthPage)} /> */}
          </Switch>
          {/* </Container> */}
          <Notifications />
        </React.Fragment>
      </ConnectedRouter>
    </React.Fragment>
  )
}

export default Routes
